import React from 'react';

import { clsx } from 'clsx';

import { PartnersCard } from 'src/components/pages/PartnersPage/types';

import styles from './Card.scss';

const Card = ({
  item,
  cardStyle,
  bigCard,
}: {
  item: PartnersCard;
  cardStyle?: string;
  bigCard?: boolean;
}) => (
  <div className={clsx(styles.cardContainer, cardStyle, styles.gradientBackground)}>
    <div>
      <div
        className={clsx(styles.title, { [styles.bigTitle]: bigCard })}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
      <div className={styles.subTitle} dangerouslySetInnerHTML={{ __html: item.subTitle }} />
    </div>
    <img src={item.icon} className={clsx(styles.image, { [styles.bigImage]: bigCard })} />
  </div>
);

export default Card;
